"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pieceImages = exports.moveAnnotations = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactChessboard = require("react-chessboard");
var _WhitePawn = _interopRequireDefault(require("/node_modules/chessboard-package/assets/ChessPieces/White-Pawn.svg"));
var _WhiteRook = _interopRequireDefault(require("/node_modules/chessboard-package/assets/ChessPieces/White-Rook.svg"));
var _WhiteQueen = _interopRequireDefault(require("/node_modules/chessboard-package/assets/ChessPieces/White-Queen.svg"));
var _WhiteKnight = _interopRequireDefault(require("/node_modules/chessboard-package/assets/ChessPieces/White-Knight.svg"));
var _WhiteKing = _interopRequireDefault(require("/node_modules/chessboard-package/assets/ChessPieces/White-King.svg"));
var _WhiteBishop = _interopRequireDefault(require("/node_modules/chessboard-package/assets/ChessPieces/White-Bishop.svg"));
var _BlackPawn = _interopRequireDefault(require("/node_modules/chessboard-package/assets/ChessPieces/Black-Pawn.svg"));
var _BlackRook = _interopRequireDefault(require("/node_modules/chessboard-package/assets/ChessPieces/Black-Rook.svg"));
var _BlackQueen = _interopRequireDefault(require("/node_modules/chessboard-package/assets/ChessPieces/Black-Queen.svg"));
var _BlackKnight = _interopRequireDefault(require("/node_modules/chessboard-package/assets/ChessPieces/Black-Knight.svg"));
var _BlackKing = _interopRequireDefault(require("/node_modules/chessboard-package/assets/ChessPieces/Black-King.svg"));
var _BlackBishop = _interopRequireDefault(require("/node_modules/chessboard-package/assets/ChessPieces/Black-Bishop.svg"));
var _BlackPawnCaptured = _interopRequireDefault(require("/node_modules/chessboard-package/assets/ChessPieces/Black-Pawn-Captured.svg"));
var _BlackBishopCaptured = _interopRequireDefault(require("/node_modules/chessboard-package/assets/ChessPieces/Black-Bishop-Captured.svg"));
var _BlackKnightCaptured = _interopRequireDefault(require("/node_modules/chessboard-package/assets/ChessPieces/Black-Knight-Captured.svg"));
var _BlackRookCaptured = _interopRequireDefault(require("/node_modules/chessboard-package/assets/ChessPieces/Black-Rook-Captured.svg"));
var _BlackKingCaptured = _interopRequireDefault(require("/node_modules/chessboard-package/assets/ChessPieces/Black-King-Captured.svg"));
var _BlackQueenCaptured = _interopRequireDefault(require("/node_modules/chessboard-package/assets/ChessPieces/Black-Queen-Captured.svg"));
var _with_the_idea = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/with_the_idea.svg"));
var _with_compensation = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/with_compensation.svg"));
var _time_trouble = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/time_trouble.svg"));
var _counter_play = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/counter_play.svg"));
var _attack = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/attack.svg"));
var _initiative = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/initiative.svg"));
var _development = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/development.svg"));
var _black_is_winning = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/black_is_winning.svg"));
var _white_is_winning = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white_is_winning.svg"));
var _black_is_better = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/black_is_better.svg"));
var _white_is_better = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white_is_better.svg"));
var _black_is_slightly_better = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/black_is_slightly_better.svg"));
var _white_is_slightly_better = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white_is_slightly_better.svg"));
var _unclear_position = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/unclear_position.svg"));
var _equal_position = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/equal_position.svg"));
var _zugzwand = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/zugzwand.svg"));
var _only_move = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/only_move.svg"));
var _dubious_move = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/dubious_move.svg"));
var _interesting_move = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/interesting_move.svg"));
var _blunder = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/blunder.svg"));
var _mistake = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/mistake.svg"));
var _good_move = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/good_move.svg"));
var _with_the_idea_white = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white-color/with_the_idea_white.svg"));
var _with_compensation_white = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white-color/with_compensation_white.svg"));
var _time_trouble_white = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white-color/time_trouble_white.svg"));
var _counter_play_white = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white-color/counter_play_white.svg"));
var _attack_white = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white-color/attack_white.svg"));
var _initiative_white = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white-color/initiative_white.svg"));
var _development_white = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white-color/development_white.svg"));
var _black_is_winning_white = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white-color/black_is_winning_white.svg"));
var _white_is_winning_white = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white-color/white_is_winning_white.svg"));
var _black_is_better_white = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white-color/black_is_better_white.svg"));
var _white_is_better_white = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white-color/white_is_better_white.svg"));
var _black_is_slightly_better_white = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white-color/black_is_slightly_better_white.svg"));
var _white_is_slightly_better_white = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white-color/white_is_slightly_better_white.svg"));
var _unclear_position_white = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white-color/unclear_position_white.svg"));
var _equal_position_white = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white-color/equal_position_white.svg"));
var _zugzwand_white = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white-color/zugzwand_white.svg"));
var _only_move_white = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white-color/only_move_white.svg"));
var _dubious_move_white = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white-color/dubious_move_white.svg"));
var _interesting_move_white = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white-color/interesting_move_white.svg"));
var _blunder_white = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white-color/blunder_white.svg"));
var _mistake_white = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white-color/mistake_white.svg"));
var _good_move_white = _interopRequireDefault(require("/node_modules/chessboard-package/assets/Annotation/white-color/good_move_white.svg"));
var _CCColors = _interopRequireDefault(require("../Utils/CCColors"));
var _excluded = ["disabled", "position", "onMove", "lastMove", "chess", "kingInCheckSquare", "boardOrientation", "selectedSquare", "possibleMoves", "onSquareSelected", "setSelectedSquare", "setPossibleMoves", "restrictedPiece", "restrictPiece", "colorTheme", "annotation"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function isDarkSquare(square) {
  var file = square.charCodeAt(0); // Letter (a-h)
  var rank = parseInt(square[1], 10); // Number (1-8)
  return (file + rank) % 2 === 0;
}

// export
// Create an object mapping piece codes to image paths
var pieceImages = exports.pieceImages = {
  wP: _WhitePawn["default"],
  wR: _WhiteRook["default"],
  wQ: _WhiteQueen["default"],
  wN: _WhiteKnight["default"],
  wK: _WhiteKing["default"],
  wB: _WhiteBishop["default"],
  bP: _BlackPawn["default"],
  bR: _BlackRook["default"],
  bQ: _BlackQueen["default"],
  bN: _BlackKnight["default"],
  bK: _BlackKing["default"],
  bB: _BlackBishop["default"],
  bPC: _BlackPawnCaptured["default"],
  bBC: _BlackBishopCaptured["default"],
  bNC: _BlackKnightCaptured["default"],
  bRC: _BlackRookCaptured["default"],
  bQC: _BlackQueenCaptured["default"],
  bKC: _BlackKingCaptured["default"]
};
var moveAnnotations = exports.moveAnnotations = {
  "With the idea": {
    icon: _with_the_idea["default"],
    white_icon: _with_the_idea_white["default"]
  },
  "With compensation": {
    icon: _with_compensation["default"],
    white_icon: _with_compensation_white["default"]
  },
  "Time trouble": {
    icon: _time_trouble["default"],
    white_icon: _time_trouble_white["default"]
  },
  "Counter-play": {
    icon: _counter_play["default"],
    white_icon: _counter_play_white["default"]
  },
  Attack: {
    icon: _attack["default"],
    white_icon: _attack_white["default"]
  },
  Initiative: {
    icon: _initiative["default"],
    white_icon: _initiative_white["default"]
  },
  Development: {
    icon: _development["default"],
    white_icon: _development_white["default"]
  },
  "Black is winning": {
    icon: _black_is_winning["default"],
    white_icon: _black_is_winning_white["default"]
  },
  "White is winning": {
    icon: _white_is_winning["default"],
    white_icon: _white_is_winning_white["default"]
  },
  "Black is better": {
    icon: _black_is_better["default"],
    white_icon: _black_is_better_white["default"]
  },
  "White is better": {
    icon: _white_is_better["default"],
    white_icon: _white_is_better_white["default"]
  },
  "Black is slightly better": {
    icon: _black_is_slightly_better["default"],
    white_icon: _black_is_slightly_better_white["default"]
  },
  "White is slightly better": {
    icon: _white_is_slightly_better["default"],
    white_icon: _white_is_slightly_better_white["default"]
  },
  "Unclear position": {
    icon: _unclear_position["default"],
    white_icon: _unclear_position_white["default"]
  },
  "Equal position": {
    icon: _equal_position["default"],
    white_icon: _equal_position_white["default"]
  },
  Zugzwang: {
    icon: _zugzwand["default"],
    white_icon: _zugzwand_white["default"]
  },
  "Only move": {
    icon: _only_move["default"],
    white_icon: _only_move_white["default"]
  },
  "Dubious move": {
    icon: _dubious_move["default"],
    white_icon: _dubious_move_white["default"]
  },
  "Interesting move": {
    icon: _interesting_move["default"],
    white_icon: _interesting_move_white["default"]
  },
  Blunder: {
    icon: _blunder["default"],
    white_icon: _blunder_white["default"]
  },
  Mistake: {
    icon: _mistake["default"],
    white_icon: _mistake_white["default"]
  },
  "Good move": {
    icon: _good_move["default"],
    white_icon: _good_move_white["default"]
  }
};

// Create a function to generate the piece theme using the mapping
var createPieceTheme = function createPieceTheme(pieceImages) {
  return Object.keys(pieceImages).reduce(function (theme, piece) {
    theme[piece] = function (_ref) {
      var isDragging = _ref.isDragging,
        squareWidth = _ref.squareWidth;
      return /*#__PURE__*/_react["default"].createElement("img", {
        src: pieceImages[piece],
        alt: piece,
        style: {
          height: squareWidth
        }
      });
    };
    return theme;
  }, {});
};
var ChessboardComponentInner = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var disabled = props.disabled,
    position = props.position,
    onMove = props.onMove,
    lastMove = props.lastMove,
    chess = props.chess,
    kingInCheckSquare = props.kingInCheckSquare,
    boardOrientation = props.boardOrientation,
    selectedSquare = props.selectedSquare,
    possibleMoves = props.possibleMoves,
    onSquareSelected = props.onSquareSelected,
    setSelectedSquare = props.setSelectedSquare,
    setPossibleMoves = props.setPossibleMoves,
    restrictedPiece = props.restrictedPiece,
    restrictPiece = props.restrictPiece,
    colorTheme = props.colorTheme,
    _props$annotation = props.annotation,
    annotation = _props$annotation === void 0 ? null : _props$annotation,
    rest = _objectWithoutProperties(props, _excluded);
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    arrows = _useState2[0],
    setArrows = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    dragStartSquare = _useState4[0],
    setDragStartSquare = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    promotionSourceSquare = _useState6[0],
    setPromotionSourceSquare = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    startPieceDrag = _useState8[0],
    setStartPieceDrag = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState9, 2),
    promotionTargetSquare = _useState10[0],
    setPromotionTargetSquare = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showPromotionDialog = _useState12[0],
    setShowPromotionDialog = _useState12[1];
  var _useState13 = (0, _react.useState)(null),
    _useState14 = _slicedToArray(_useState13, 2),
    promotionPiece = _useState14[0],
    setPromotionPiece = _useState14[1];
  var _useState15 = (0, _react.useState)(null),
    _useState16 = _slicedToArray(_useState15, 2),
    lastMoveSquare = _useState16[0],
    setLastMoveSquare = _useState16[1];
  (0, _react.useEffect)(function () {
    // Set the target square of the last move
    if (lastMove !== null && lastMove !== void 0 && lastMove.to) {
      setLastMoveSquare(lastMove.to);
    }
  }, [lastMove]);
  (0, _react.useEffect)(function () {
    var chessboardEl = document.getElementById("BoardWithCustomArrows");
    if (chessboardEl) {
      chessboardEl.addEventListener("mousedown", handleMouseDown);
      chessboardEl.addEventListener("mousemove", handleMouseMove);
      chessboardEl.addEventListener("mouseup", handleMouseUp);

      // Prevent context menu on right click
      chessboardEl.oncontextmenu = function (e) {
        return e.preventDefault();
      };
    }
    return function () {
      if (chessboardEl) {
        chessboardEl.removeEventListener("mousedown", handleMouseDown);
        chessboardEl.removeEventListener("mousemove", handleMouseMove);
        chessboardEl.removeEventListener("mouseup", handleMouseUp);
        chessboardEl.oncontextmenu = null;
      }
    };
  }, [handleMouseDown, handleMouseMove, handleMouseUp]);
  var getSquareName = function getSquareName(file, rank, boardOrientation) {
    if (boardOrientation === "white") {
      return file + rank; // Default orientation (white)
    } else {
      var reversedFile = String.fromCharCode("h".charCodeAt(0) - (file.charCodeAt(0) - "a".charCodeAt(0)));
      var reversedRank = 9 - rank; // Reverse rank
      return reversedFile + reversedRank;
    }
  };
  var renderAnnotation = function renderAnnotation() {
    if (lastMoveSquare) {
      var _moveAnnotations$anno;
      var _lastMoveSquare$split = lastMoveSquare.split(""),
        _lastMoveSquare$split2 = _slicedToArray(_lastMoveSquare$split, 2),
        file = _lastMoveSquare$split2[0],
        rank = _lastMoveSquare$split2[1];
      var correctSquare = getSquareName(file, parseInt(rank, 10), boardOrientation);
      var _correctSquare$split = correctSquare.split(""),
        _correctSquare$split2 = _slicedToArray(_correctSquare$split, 2),
        correctFile = _correctSquare$split2[0],
        correctRank = _correctSquare$split2[1];
      var left = (correctFile.charCodeAt(0) - "a".charCodeAt(0)) * 12.5 + "%";
      var top = (8 - parseInt(correctRank)) * 12.5 + "%";
      if (!annotation) return null;
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: lastMoveSquare,
        style: {
          position: "absolute",
          top: top,
          left: left,
          width: "12.5%",
          height: "12.5%",
          pointerEvents: "none"
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.annotationContainer
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: moveAnnotations === null || moveAnnotations === void 0 || (_moveAnnotations$anno = moveAnnotations[annotation]) === null || _moveAnnotations$anno === void 0 ? void 0 : _moveAnnotations$anno.white_icon,
        alt: "annotation",
        style: styles.icon
      })));
    }
    return null;
  };
  var handleMouseDown = (0, _react.useCallback)(function (event) {
    if (event.button === 2) {
      var square = getSquareFromMouseEvent(event);
      if (square) {
        setDragStartSquare(square);
      }
      event.preventDefault();
    }
  }, []);
  var handleMouseMove = (0, _react.useCallback)(function (event) {
    if (!dragStartSquare) return;
    var currentSquare = getSquareFromMouseEvent(event);
    // Update some temporary state or UI to show the in-progress arrow if needed
  }, [dragStartSquare]);
  var handleMouseUp = (0, _react.useCallback)(function (event) {
    if (dragStartSquare) {
      var endSquare = getSquareFromMouseEvent(event);
      if (endSquare) {
        setArrows(function (prevArrows) {
          return [].concat(_toConsumableArray(prevArrows), [{
            from: dragStartSquare,
            to: endSquare
          }]);
        });
      }
    }
    setDragStartSquare(null);
  }, [dragStartSquare]);
  var onPieceDrop = (0, _react.useCallback)(function (sourceSquare, targetSquare, promotion) {
    var piece = chess.get(sourceSquare); // Get the piece on the source square
    console.log("promotion..", promotion, restrictedPiece);
    // Check if restriction is enabled, and only allow moves from the restricted piece
    if (restrictedPiece && ((piece === null || piece === void 0 ? void 0 : piece.type) !== restrictedPiece.type || sourceSquare !== restrictedPiece.square)) {
      return false; // Prevent the move if it's not the restricted piece
    }
    // if (restrictedPiece && piece?.color !== restrictedPiece.color) {
    //   return false; // Prevent the move if it's not the restricted piece
    // }

    var isMoveSuccessful = onMove(sourceSquare, targetSquare, promotion);

    // If the move is valid, proceed
    if (isMoveSuccessful) {
      console.log("inside move success piece drop");
      setSelectedSquare(null);
      setPossibleMoves([]);
    }
    return isMoveSuccessful;
  }, [chess, restrictedPiece, onMove, setSelectedSquare, setPossibleMoves]);
  var onSquareClick = (0, _react.useCallback)(function (square) {
    var _ref$current;
    console.log("square clicked", square);
    (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.clearPremoves(false);
    if (disabled) return;
    var piece = chess.get(square);
    setStartPieceDrag(false);

    // Handle restricted piece (if necessary)
    if (restrictedPiece && !possibleMoves.includes(square) && ((piece === null || piece === void 0 ? void 0 : piece.type) !== restrictedPiece.type || square !== restrictedPiece.square)) {
      return false; // Do nothing if the clicked piece is not the restricted one
    }
    if (restrictPiece) {
      restrictPiece(piece, square);
    }

    // If the selected square is valid and it's a promotion move
    if (selectedSquare && possibleMoves.includes(square)) {
      var pieceDetails = chess.get(selectedSquare);

      // Detect if the move involves a pawn promotion
      if ((pieceDetails === null || pieceDetails === void 0 ? void 0 : pieceDetails.type) === "p" && (pieceDetails === null || pieceDetails === void 0 ? void 0 : pieceDetails.color) === "w" && square[1] === "8" || (pieceDetails === null || pieceDetails === void 0 ? void 0 : pieceDetails.type) === "p" && (pieceDetails === null || pieceDetails === void 0 ? void 0 : pieceDetails.color) === "b" && square[1] === "1") {
        setPromotionSourceSquare(selectedSquare);
        setPromotionTargetSquare(square);
        setShowPromotionDialog(true); // Show promotion dialog
        return;
      }

      // Otherwise, just make a normal move
      onMove(selectedSquare, square);
      setSelectedSquare(null);
      setPossibleMoves([]);
      return;
    }

    // Select the piece and show possible moves
    setSelectedSquare(square);
    var moves = chess.moves({
      square: square,
      verbose: true
    }).map(function (move) {
      return move.to;
    });
    setPossibleMoves(moves);
  }, [chess, onMove, possibleMoves, selectedSquare, disabled, restrictedPiece]);
  var onPromotionPieceSelect = (0, _react.useCallback)(function (promotedPiece) {
    // Handle promotion for both drag-and-drop and click-based moves
    if (promotionSourceSquare && promotionTargetSquare) {
      onMove(promotionSourceSquare, promotionTargetSquare, promotedPiece);
      setPromotionSourceSquare(null);
      setPromotionTargetSquare(null);
      setShowPromotionDialog(false); // Close the promotion modal
    }
  }, [promotionSourceSquare, promotionTargetSquare, onMove]);

  //   ,
  //   [selectedSquare, possibleMoves, onMove, onSquareSelected, disabled]
  // );

  (0, _react.useEffect)(function () {
    if (selectedSquare) {
      squareStyles[selectedSquare] = {
        backgroundColor: "rgba(20, 85, 30, 0.5)"
      };
    }
    if (possibleMoves) {
      possibleMoves === null || possibleMoves === void 0 || possibleMoves.forEach(function (move) {
        squareStyles[move] = {
          backgroundColor: "rgba(20, 85, 30, 0.3)"
        };
      });
    }
    console.log("inside restricted piece useEffect :", restrictedPiece);
  }, [selectedSquare, possibleMoves]);
  var color = colorTheme;
  var lightColor = _CCColors["default"].ChessBoard.Light;
  var darkColor = _CCColors["default"].Progress.Bar;
  var startColor = _CCColors["default"].ChessBoard.StartColor;
  var endColor = _CCColors["default"].ChessBoard.EndColor;
  if (color) {
    if (color === "green-white") {
      lightColor = _CCColors["default"].ChessBoard.GreenLightColor;
      darkColor = _CCColors["default"].ChessBoard.GreenDarkColor;
      startColor = _CCColors["default"].ChessBoard.GreenStartColor;
      endColor = _CCColors["default"].ChessBoard.GreenEndColor;
    } else if (color === "blue-white") {
      lightColor = _CCColors["default"].ChessBoard.BlueLightColor;
      darkColor = _CCColors["default"].ChessBoard.BlueDarkColor;
      startColor = _CCColors["default"].ChessBoard.BlueStartColor;
      endColor = _CCColors["default"].ChessBoard.BlueEndColor;
    }
  }
  var squareStyles = {};
  ["a", "b", "c", "d", "e", "f", "g", "h"].forEach(function (r) {
    return ["1", "2", "3", "4", "5", "6", "7", "8"].forEach(function (c) {
      var square = r + c;
      var isDark = isDarkSquare(square);
      squareStyles[square] = {
        border: "2px solid transparent",
        boxSizing: "border-box",
        backgroundColor: isDark ? darkColor : lightColor,
        color: isDark ? lightColor : darkColor // Dynamic notation color based on square color
      };
    });
  });
  if (lastMove !== null && lastMove !== void 0 && lastMove.from && isValidSquare(lastMove.from)) {
    // squareStyles[lastMove.from].backgroundColor = "rgb(120, 113, 64)";
    squareStyles[lastMove.from].backgroundColor = startColor;
  }
  if (lastMove !== null && lastMove !== void 0 && lastMove.to && isValidSquare(lastMove.to)) {
    // squareStyles[lastMove.to].backgroundColor = "rgb(196, 181, 57)";
    squareStyles[lastMove.to].backgroundColor = endColor;
    squareStyles[lastMove.to].border = "2px solid rgb(120, 113, 64)";
  }
  if (kingInCheckSquare && isValidSquare(kingInCheckSquare)) {
    console.log("inside set king in check useeffect 3", kingInCheckSquare);
    squareStyles[kingInCheckSquare].background = "radial-gradient(transparent 60%, #EB5757)";
  }
  if (restrictedPiece) {
    squareStyles[restrictedPiece === null || restrictedPiece === void 0 ? void 0 : restrictedPiece.square] = {
      backgroundColor: "rgba(20, 85, 35, 0.3)"
    };
  }
  // Handle drag start
  var onPieceDragBegin = (0, _react.useCallback)(function (piece, sourceSquare) {
    // Set the source square when dragging starts
    console.log(sourceSquare, "onPieceDragBegin");
    setStartPieceDrag(true);
    var Piece = {
      type: piece[1].toLowerCase(),
      square: sourceSquare,
      color: piece[0]
    };
    if (restrictPiece) {
      restrictPiece(Piece, sourceSquare);
    }
    return true; // Allow normal moves
  }, []);

  // Handle drag end
  var onPieceDragEnd = (0, _react.useCallback)(function (piece, targetSquare) {
    // setStartPieceDrag(false);

    return true; // Allow normal moves
  }, [chess, promotionSourceSquare]);
  console.log("inside set king in check useeffect 4,", squareStyles);
  var pieceTheme = createPieceTheme(pieceImages);
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      position: "relative"
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactChessboard.Chessboard, _extends({
    ref: ref,
    position: position,
    arePiecesDraggable: disabled ? false : true,
    customBoardStyle: disabled ? {
      pointerEvents: "none"
    } : {},
    showBoardNotation: disabled ? false : true,
    promotionDialogVariant: "modal",
    customPieces: pieceTheme,
    customDarkSquareStyle: {
      backgroundColor: darkColor
    },
    customLightSquareStyle: {
      backgroundColor: lightColor
    },
    onPieceDrop: onPieceDrop,
    onSquareClick: onSquareClick,
    customNotationStyle: {
      color: "auto",
      fontSize: 16
      // fontWeight: "bold",
    },
    customSquareStyles: squareStyles,
    boardOrientation: boardOrientation,
    id: "BoardWithCustomArrows"
    // customArrows={customArrows}
    ,
    customArrows: arrows,
    customArrowColor: "rgb(245, 192, 0)",
    showPromotionDialog: showPromotionDialog // Show promotion dialog when needed
  }, !startPieceDrag && {
    onPromotionPieceSelect: onPromotionPieceSelect
  }, {
    onPieceDragBegin: onPieceDragBegin,
    onPieceDragEnd: onPieceDragEnd
    // onArrowsChange={(squares) => {
    //   console.log(squares, "squares");
    // }}
  }, rest)), renderAnnotation());
});
function isValidSquare(square) {
  return /^[a-h][1-8]$/.test(square);
}
var styles = {
  annotationContainer: {
    position: "absolute",
    top: "-15%",
    // Positioning within the square
    right: "-20%",
    width: "40%",
    height: "40%",
    minWidth: "25px",
    minHeight: "25px",
    backgroundColor: _CCColors["default"].ChessBoard.OrangeColor,
    // Circle color
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  icon: {
    width: "14px",
    height: "14px"
  }
};
var _default = exports["default"] = ChessboardComponentInner;